// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';
import { Device } from '@ta/lithium.context';
import classnames from '@ta/common.classnames';
import Button from '@ta/core-ui.button';
import Localize from '@ta/platform.i18n';
import BackButton from './BackButton';
import styles from './SubmitVoteButton.css';

type Props = {|
  /** The callback to execute when user wants to submit */
  onSubmit?: () => mixed,
  /** If true, buttons should appear disabled */
  disabled?: boolean,
  /** If an onBack callback is passed in, then a back button will appear */
  onBack?: () => mixed,
|};

const SubmitVoteButton = ({ disabled, onBack, onSubmit }: Props) => {
  const isSticky = React.useContext(Device).viewportCategory === 'MOBILE';
  return (
    <React.Fragment>
      {isSticky && (
        <div className={styles.stickySpacer}>
          <Button disabled>{null}</Button>
        </div>
      )}
      <div className={classnames(styles.wrapper, isSticky && styles.sticky)}>
        {onBack && (
          <div className={styles.button}>
            <BackButton onBack={onBack} />
          </div>
        )}
        <div className={styles.button}>
          <Button theme="primary" disabled={disabled} onClick={onSubmit} fullWidth>
            <Localize id="common_Submit" />
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SubmitVoteButton;
